/**
 * BottomNav — barra de navegación inferior fija (móvil), s64.
 *
 * Tres accesos permanentes: Inicio · Plan · Carreras. Vive en el shell
 * autenticado (ProtectedRoute la monta UNA vez; onboarding la apaga con
 * `bottomNav={false}`), no por página. "Eliminar plan" NO entra: es
 * destructivo, no navegación permanente (decisión Yan 07/09).
 *
 * Visibilidad: SOLO < md (768px), el breakpoint que el repo ya usa para
 * cambios de layout (sm:/md:, sin lg:). Tablets en vertical (768) y
 * desktop: `md:hidden` y la navegación in-flow actual sigue tal cual.
 * Sin librería de iconos en el repo → texto limpio en estilo eyebrow
 * (text-xs uppercase tracking-widest), sin dependencias nuevas.
 *
 * Contrato CSS (globals.css): el atributo `data-bottom-nav` activa la
 * variable `--bottom-nav-h` (= 3.5rem + inset inferior) vía `html:has()`
 * solo en móvil; body (padding), min-h-app, bottom-toast, bottom-nav y
 * pb-safe-nav (tailwind.config.ts) la consumen para que nada quede
 * tapado. La altura visual (`h-14` = 3.5rem) y la variable DEBEN ir a
 * la par: por eso la línea superior es una sombra (0 px de layout) y no
 * un border-t, que sumaría 1 px fuera de la variable.
 */
import { NavLink } from "react-router-dom";

import { t } from "@/i18n/es";

interface NavItem {
  to: string;
  label: string;
  /** `end`: activo solo con match exacto (Inicio no se activa en /plan). */
  end: boolean;
  testId: string;
}

const ITEMS: readonly NavItem[] = [
  { to: "/", label: t.nav.home, end: true, testId: "bottom-nav-home" },
  { to: "/plan", label: t.nav.plan, end: false, testId: "bottom-nav-plan" },
  {
    to: "/carreras",
    label: t.nav.races,
    end: false,
    testId: "bottom-nav-races",
  },
];

export function BottomNav() {
  return (
    <nav
      data-bottom-nav=""
      data-testid="bottom-nav"
      aria-label={t.nav.label}
      className="fixed inset-x-0 bottom-0 z-40 bg-carbon pb-[env(safe-area-inset-bottom)] shadow-[0_-1px_0_0_theme(colors.border-subtle)] md:hidden"
    >
      <ul className="mx-auto flex h-14 max-w-md items-stretch">
        {ITEMS.map((item) => (
          <li key={item.to} className="flex flex-1">
            <NavLink
              to={item.to}
              end={item.end}
              data-testid={item.testId}
              className={({ isActive }) =>
                `flex flex-1 items-center justify-center border-t-2 text-xs uppercase tracking-widest transition-colors duration-fast ${
                  isActive
                    ? "border-lime font-medium text-lime"
                    : "border-transparent text-bone-muted hover:text-bone"
                }`
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
